import {
    useEffect,
    useState,
    useRef
} from 'react';

export default function  useLoadGsiScript(options) {
    const { nonce, onScriptLoadSuccess, onScriptLoadError } = options;

    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] =
    useState(false);

    const onScriptLoadSuccessRef = useRef(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;

    const onScriptLoadErrorRef = useRef(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;

    useEffect(() => {
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.crossOrigin = 'anonymous';
        script.src = 'https://connect.facebook.net/en_US/sdk.js';
        script.onload = () => {
            setScriptLoadedSuccessfully(true);
            onScriptLoadSuccessRef.current?.();
        };

        script.onerror = () => {
            setScriptLoadedSuccessfully(false);
            onScriptLoadErrorRef.current?.();
        }

        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, [nonce]);

    return scriptLoadedSuccessfully;
}

